/**
 * Form Fields.
 * @format
 */

import React from 'react';
import SelectList from './select-list';
import TextInput from './text-input';
import Checkbox from './checkbox';
import { InputProperties, FieldProperties } from '../form-modals';

/**
 * Form Fields.
 *
 * @param {array} fieldList
 */
const FormFields = (props: InputProperties): JSX.Element | null => {
  const { fieldList, register, errors, region, repeatingArrayKey } = props;

  if (fieldList && fieldList.length > 0) {
    return fieldList.map((field: FieldProperties) => {
      const { type, id, dependentField } = field;
      const fieldId = region ? `${region}-${id}` : id;

      if (!dependentField) {
        if (
          type === 'email' ||
          type === 'textarea' ||
          type === 'text' ||
          type === 'tel' ||
          type === 'url'
        ) {
          return (
            <TextInput
              fieldProperties={field}
              key={fieldId}
              register={register}
              errors={errors}
              fieldId={fieldId}
              repeatingArrayKey={repeatingArrayKey}
            />
          );
        } else if (type === 'checkbox') {
          return (
            <Checkbox
              fieldProperties={field}
              key={fieldId}
              register={register}
              errors={errors}
              fieldId={fieldId}
            />
          );
        } else if (type === 'select') {
          return (
            <SelectList
              fieldProperties={field}
              key={fieldId}
              register={register}
              errors={errors}
              fieldId={fieldId}
            />
          );
        }
      }
      return null;
    });
  }
  return null;
};
export default FormFields;
